import i18n from '../../../../common/i18n';
import SuccessIcon from '../../../../icons/SuccessIcon';
import { getConfig } from '../../../registration/util/config';
import RegistrationInfo from '../../../registration/view/RegistrationInfo';

function ForcedActionStatusPending() {
    return (
        <RegistrationInfo
            title={i18n('nui.documentsUpload.success.title')}
            subTitle={i18n('nui.documentsUpload.success.subtitle')}
            icon={<SuccessIcon />}
            buttonLabel={i18n('nui.button.continue')}
            onClick={() => getConfig().gotoHomepage()}
        />
    );
}

export default ForcedActionStatusPending;
